<template>
  <div class="manage-content">
    <div class="location">企业管理中心 / 消息通知</div>
    <div class="white-bg shadow margin-top-20 padding30 radius" v-if="isShow === 'list'">
      <div class="noNumber" v-if="info.length === 0">暂无消息</div>
      <div v-for="(item,index) in info" :key="index">
        <div class="message-item relative" @click="goToDetail(item.id)">{{item.title}}<el-tag size="mini" v-if="item.is_read == 0">未读</el-tag><el-tag type="info" size="mini" v-if="item.is_read == 1">已读</el-tag><span class="time absolute" v-text="new Date(parseInt(item.create_time) * 1000).toLocaleString('chinese',{hour12:false}).replace(/:d{1,2}$/,'')"></span></div>
<!--          <el-collapse-transition>-->
<!--          <div class="message-con" v-show="index===limit">-->
<!--            <p>{{item.content.content[0]}}</p>-->
<!--            <p>{{item.content.content[1]}}</p>-->
<!--            <p>{{item.content.content[2]}}</p>-->
<!--            <p>{{item.content.content[3]}}</p>-->
<!--            <p>{{item.content.content[4]}}</p>-->
<!--            <p v-if="item.content.task_id"><router-link :to="{path:'/enterprise/detail',query:{id:item.content.task_id}}"><el-link type="primary">查看订单</el-link></router-link></p>-->
<!--          </div>-->
<!--          </el-collapse-transition>-->
      </div>
      <div class="pages" v-if="count >= 10">
        <el-pagination
                @current-change="current_change"
                :current-page.sync="currentPage"
                :page-size="10"
                layout="prev, pager, next"
                :total="count"
        ></el-pagination>
      </div>
    </div>
    <div class="white-bg shadow margin-top-20 padding30 radius" v-if="isShow === 'detail'">
      <div class="message-con">
        <p class="title">{{title}}</p>
        <div class="message-main">
          <p>{{content[0]}}</p>
          <p>{{content[1]}}</p>
          <p>{{content[2]}}</p>
          <p>{{content[3]}}</p>
          <p>{{content[4]}}</p>
          <p v-if="task_id"><router-link :to="{path:'/enterprise/detail',query:{id:task_id}}"><el-link type="primary">查看订单</el-link></router-link></p>
        </div>
      </div>
      <div class="flex align-items justify-content"><el-button @click="goBack" style="width:20%;">返回</el-button></div>
    </div>
  </div>
</template>
<script>
import {newsData,newsInfo} from '@/config/api.js'
export default {
  name: 'Message',
  inject:['reload'],
  data () {
    return {
      info: [],
      content: [],
      limit: -1,
      isShow: 'list',
      title: '',
      task_id: '',
      count: 0,
      currentPage: 1
    }
  },
  methods: {
    getMessage () {
      let data = {
        user_type:0,
        user_id:this.$store.state.user_id,
        page: this.currentPage - 1,
      };
      this.$post(newsData,data)
              .then(res => {
                let data = res.data;
                this.info = data.info;
                this.count = Number(data.count);
              })
              .catch(err => {
                window.console.log(err)
              })
    },
    current_change (currentPage) {
      this.currentPage = currentPage;
      this.getMessage();
    },
    goToDetail (newId) {
      this.isShow = 'detail';
      let data = {
        id: newId
      };
      this.$post(newsInfo,data)
              .then(res => {
                // window.console.log(res.data);
                let data = res.data;
                this.title = data.title;
                this.content = data.content.content;
                this.task_id = data.content.task_id;
              })
    },
    goBack () {
      this.reload();
    }
    // toggle(index) {
    //   if (index===this.limit) {
    //     this.limit=-1
    //   }else{
    //     this.limit=index;
    //   }
    // }
  },
  mounted() {
    this.getMessage()
  },
}
</script>
<style scoped>
  .message-item{width:100%;height:60px;line-height: 60px;font-size: 14px;border-bottom: 1px #f9f9f9 solid;cursor: pointer;-webkit-transition: all 0.3s ease-in;-moz-transition: all 0.3s ease-in;transition: all 0.3s ease-in;-o-transition: all 0.3s ease-in;}
  .message-item:hover{color:#fe9539;}
  .message-item .time{right:0;height:60px;line-height: 60px;color:#999;}
  .message-con{line-height:36px;}
  .message-con .message-main{padding:10px 20px;background: #f9f9f9;margin:10px 0 30px 0;}
  .message-con .title{font-size: 14px;color:#000;}
  .noNumber{text-align: center;color:#999;padding:10px 0;}
</style>
